import React from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  FunctionField,
  ListProps,
  SelectInput,
} from "react-admin";
import StatusField from "components/StatusField";
import { statusList } from "./const";
import ListWrapper from "../../components/ListWrapper";
import ListShowButton from "../../components/ListShowButton";
import ActionsMenu from "../../components/ActionsMenu";

const AssistantFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const AssistantList = (props: ListProps) => {
  const breadcrumb = [{ link: "/busAssistants", title: "Bus Assistants" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Bus Assistants"
        isNotHaveSchoolFilter
        denseMode
        {...props}
        exporter={false}
        hasCreate={false}
        filters={<AssistantFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="show">
          <TextField source="id" emptyText="-" />
          <TextField source="fullName" emptyText="-" />
          <TextField source="contactNumber" emptyText="-" />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu render={[<ListShowButton record={record} />]} />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default AssistantList;
